module.exports = __webpack_public_path__ + "static/media/handyman.609b0769.svg";